module.exports = __webpack_public_path__ + "static/img/refining1.583964a9.png";